import * as IoC from 'inversify';
import { BookmarkDataStoreSymbol, BookmarkDataStore } from '../common/bookmark-data-store';
import { bookmarkCommonTrackingModule } from '../common/di'
import { Scorm2004BookmarkDataStore } from './scorm2004-bookmark-data-store';

const bookmarkScorm2004TrackingModule = new IoC.ContainerModule((bind) => {
  bind<BookmarkDataStore>(BookmarkDataStoreSymbol).to(Scorm2004BookmarkDataStore)
})

export const bookmarkScorm2004TrackingModules = [
  bookmarkCommonTrackingModule,
  bookmarkScorm2004TrackingModule,
]
